import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col } from 'antd';

import Styles from './SearchPlaceholder.module.scss';
import Text from 'Pages/Home/Components/Atoms/Text';

const SearchPlaceholder: React.FC = () => {
  return (
    <Col>
      <Text className={Styles['search-button-text']}>Type any products here</Text>
    </Col>
  )
}

export default SearchPlaceholder;